<template>
<b-row>
    <b-col cols="12">
      <b-btn class="return-btn" variant="outline-primary" @click.stop="returnhome">Return</b-btn>

      <b-jumbotron class="bulletin">
        <div class="member-name">
            <font class="member-names" size=6pt>{{member.first_name}} {{member.last_name}}</font>
        </div>

        <div id="member-content">
          <font size="4" color="grey">
          Address Line 1: {{member.address_1}} <br>
          Address Line 2: {{member.address_2}} <br>
          City: {{member.city}} <br>
          Post Code: {{member.postcode}} <br>
          Phone No.: {{member.mobile_no}} <br>
          Membership Level: {{member.membership}} <br>
          On Probation: {{member.probation}} <br>
          Member Since: {{member.member_since}} <br><br>
          </font>
        </div>

        <b-btn class="edit-btn" variant="success" @click.stop="editmember(key)">Edit</b-btn>
        <b-btn class="delete-btn" variant="danger" @click.stop="deletemember(key)">Delete</b-btn>


        <b-jumbotron class="files-jumbotron" bg-variant="white">
          <div class="member-files">
            Member Files
          </div>

          <b-btn class="upload-btn" variant="outline-info" @click="onPickFile">Upload File</b-btn>
          <input type="file" style="display: none" ref="fileInput" @change="onFilePicked" id="fileUpload">



        </b-jumbotron>
          
      </b-jumbotron>
    </b-col>
  </b-row>
</template>

<script>

import firebase from '../Firebase'
import router from '../router/index.js'

export default {
  name: 'ShowMember',
  data () {
    return {
      key: '',
      member: {},
      scrolled: false
    }
  },
  created () {
    const ref = firebase.firestore().collection('members').doc(this.$route.params.id)
    ref.get().then((doc) => {
      if (doc.exists) {
        this.key = doc.id
        this.member = doc.data()
      } else {
        alert("No such document!")
      }
    });
  },
  methods: {
    editmember (id) {
      router.push({
        name: 'EditMember',
        params: { id: id }
      })
    },
    deletemember (id) {
      firebase.firestore().collection('members').doc(id).delete().then(() => {
        router.push({
          name: 'MemberList'
        })
      }).catch((error) => {
        alert("Error removing document: ", error)
      });
    },
    returnhome (){
      router.push({
        name: "MemberList"
      })
    },
    addfile (id) {
      router.push({
        name: "UploadFile",
        params: {id: id }
      })
    },
    viewfiles (id) {
      router.push({
        name: "ViewFile",
        params: { id: id }
      })
    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const storageRef = firebase.firestore().ref().child('members')
      var file = event.target.files[0]

    }
  }
}
</script>

<style>
  .jumbotron {
    padding: 2rem;
  }
  .member-names {
    font-variant: small-caps;
  }
  .files-jumbotron {
    margin-top: 20px;
  }
  .member-files {
    margin-top: -20px;
    font-variant: small-caps;
    font-size: 18pt;
  }
  .edit-btn {
    margin-bottom: 20px;
    margin-right: 20px;
    width: 70px;
  }
  .delete-btn {
    margin-bottom: 20px;
    margin-right: 20px;
    width: 70px;
  }
  .upload-btn {
    margin-top: 10px;
  }
  .files-btn {
    margin-bottom: 20px;
    margin-right: 20px;
  }
  .return-btn {
    margin-bottom: 20px;
  }
</style>